import React from 'react';
import {
  TemplateIssueCategory, TemplateIssueCategoryTitles,
} from '../../../../../../../../constants/Types';
import Option from './Option';

interface CategoryListProps {
  category: TemplateIssueCategory,
  update,
}

const CategoryList = ({ category, update }: CategoryListProps) => <>
  {[null, ...Object.values(TemplateIssueCategory)].map((key: string, index: number) => <Option
    text={TemplateIssueCategoryTitles[key] ?? 'No category'}
    key={`template_issue_category_${key}`}
    onPress={() => update(key)}
    selected={category === key || (!key && !category)}
    testID={`template-issue-category-option#${index + 1}`}
  />)}
</>;

export default CategoryList;
